import React, { useEffect, useState } from "react";
import { supabase } from "../../services/db";
import { Link, } from "react-router-dom";
import RecipeCard from "../../components/RecipeCard";

const AllRecipes = () => {
  const [recipes, setRecipes] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  useEffect(() => {
    getRecipes();
  }, []);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  async function getRecipes() {
    const { data, error } = await supabase().from("Recipe").select();
    data && !error && setRecipes(data);
  }

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);
    return () => clearTimeout(delayInputTimeoutId);
  }, [searchValue]);

  return (
    <div className="defaultPageContainer">
      <div className="flex">
        <Link to="/">View all boards</Link>
      </div>
      <label htmlFor="search">Search</label>
      <input onChange={handleSearchChange} id="search" value={searchValue} />

      <div className="flexWrap gap10">
        {recipes
          ?.filter((recipe) => {
            if (recipe.ingredients || debouncedSearchValue) {
              return (
                recipe?.ingredients?.filter((ingredient) =>
                  ingredient?.name
                    ?.toLowerCase()
                    .includes(debouncedSearchValue.toLowerCase())
                ).length > 0 ||
                recipe.title?.toLowerCase.includes(
                  debouncedSearchValue.toLowerCase()
                )
              );
            }
            return true;
          })
          .map((recipe) => (
            <RecipeCard recipe={recipe} key={recipe.id} />
          ))}
      </div>
    </div>
  );
};
export default AllRecipes;
